<article
  class="product-card card-reveal"
  [class.has-discount]="hasDiscount()"
  (click)="openDetails()"
>

  <!-- IMAGE -->

  <div class="product-image">

    <img
      [src]="getImageUrl(product.imageUrl)"
      [alt]="getProductName()"
      loading="lazy"
    />


    <!-- DISCOUNT -->

    <span
      class="discount-badge"
      *ngIf="hasDiscount()"
    >
      -{{ product.discountPercentage }}%
    </span>


    <!-- OUT OF STOCK -->

    <span
      class="stock-badge out-of-stock"
      *ngIf="!product.isInStock"
    >
      {{ 'PRODUCT.OUT_OF_STOCK' | translate }}
    </span>

  
  </div>


  <!-- CONTENT -->

  <div class="product-content">
<div class="product-brand" *ngIf="getBrandName()">
  <span class="brand-line"></span>

  <span class="brand-diamond">◆</span>

  <span class="brand-name">
    {{ getBrandName() }}
  </span>

  <span class="brand-diamond">◆</span>

  <span class="brand-line"></span>
</div>
    <h3 class="product-name">
      {{ getProductName() }}
    </h3>


    <!-- PRICE -->

    <div class="product-price">

      <span
        class="old-price"
        *ngIf="hasDiscount()"
      >
        {{ product.price | number:'1.2-2' }}
      </span>


      <span class="current-price">
        {{ getDiscountedPrice() | number:'1.2-2' }}
      </span>

    </div>
<!-- add to cart here -->
<div class="addToCart">
<button
  type="button"
  class="add-cart-button"
  [class.added]="showAddedCheck"
  [disabled]="!product.isInStock || showAddedCheck"
  (click)="addToCart($event)"
  [attr.aria-label]="
    showAddedCheck
      ? ('PRODUCT.ADDED_TO_CART' | translate)
      : ('PRODUCT.ADD_TO_CART' | translate)
  "
>

  @if (showAddedCheck) {

    <mat-icon class="added-check-icon">
      check
    </mat-icon>

  } @else {

    <mat-icon>
      shopping_cart
    </mat-icon>

  }

</button>
 <!-- ALREADY IN CART MESSAGE -->

      <span
        class="already-in-cart-message"
        *ngIf="showAlreadyInCartMessage"
      >
        {{ 'PRODUCT.ALREADY_IN_CART' | translate }}
      </span>
</div>



     


 <!-- end add to cart-->
  </div>

</article>